export const GET_VEHICLES_REQUEST = 'GET_VEHICLES_REQUEST';
export const GET_VEHICLES_SUCCESS = 'GET_VEHICLES_SUCCESS';
export const GET_VEHICLES_FAILURE = 'GET_VEHICLES_FAILURE';

export const GET_TYPING_VEHICLES_REQUEST = 'GET_TYPING_VEHICLES_REQUEST';

export const GET_VEHICLES_TYPE_REQUEST = 'GET_VEHICLES_TYPE_REQUEST';
export const GET_VEHICLES_TYPE_SUCCESS = 'GET_VEHICLES_TYPE_SUCCESS';
export const GET_VEHICLES_TYPE_FAILURE = 'GET_VEHICLES_TYPE_FAILURE';

export const GET_VEHICLES_BRAND_REQUEST = 'GET_VEHICLES_BRAND_REQUEST';
export const GET_VEHICLES_BRAND_SUCCESS = 'GET_VEHICLES_BRAND_SUCCESS';
export const GET_VEHICLES_BRAND_FAILURE = 'GET_VEHICLES_BRAND_FAILURE';

export const GET_VEHICLES_MODEL_REQUEST = 'GET_VEHICLES_MODEL_REQUEST';
export const GET_VEHICLES_MODEL_SUCCESS = 'GET_VEHICLES_MODEL_SUCCESS';
export const GET_VEHICLES_MODEL_FAILURE = 'GET_VEHICLES_MODEL_FAILURE';

export const SUBMIT_VEHICLE_FILE_REQUEST = "SUBMIT_VEHICLE_FILE_REQUEST";
export const SUBMIT_VEHICLE_FILE_SUCCESS = "SUBMIT_VEHICLE_FILE_SUCCESS";
export const SUBMIT_VEHICLE_FILE_FAILURE = "SUBMIT_VEHICLE_FILE_FAILURE";

export const SET_VEHICLE_FILE = "SET_VEHICLE_FILE";
export const SET_VEHICLES = "SET_VEHICLES";

export const getVehiclesRequest = (filters = {}) => ({
    type: GET_VEHICLES_REQUEST,
    payload: {
        filters
    }
});

export const getTypingVehiclesRequest = (filters = {}) => ({
    type: GET_TYPING_VEHICLES_REQUEST,
    payload: {
        filters
    }
});

export const getVehiclesSuccess = vehicles => ({
    type: GET_VEHICLES_SUCCESS,
    payload: {
        vehicles
    }
});

export const getVehiclesFailure = err => ({
    type: GET_VEHICLES_FAILURE,
    error: err
});

export const getVehiclesTypeRequest = (filters = {}) => ({
    type: GET_VEHICLES_TYPE_REQUEST,
    payload: {
        filters
    }
});

export const getVehiclesTypeSuccess = vehicles_type => ({
    type: GET_VEHICLES_TYPE_SUCCESS,
    payload: {
        vehicles_type
    }
});

export const getVehiclesTypeFailure = err => ({
    type: GET_VEHICLES_TYPE_FAILURE,
    error: err
});

export const getvehiclesBrandRequest = (filters = {}) => ({
    type: GET_VEHICLES_BRAND_REQUEST,
    payload: {
        filters
    }
});

export const getvehiclesBrandSuccess = vehicles_brand => ({
    type: GET_VEHICLES_BRAND_SUCCESS,
    payload: {
        vehicles_brand
    }
});

export const getvehiclesBrandFailure = err => ({
    type: GET_VEHICLES_BRAND_FAILURE,
    error: err
});

export const getvehiclesModelRequest = (filters = {}) => ({
    type: GET_VEHICLES_MODEL_REQUEST,
    payload: {
        filters
    }
});

export const getvehiclesModelSuccess = vehicles_model => ({
    type: GET_VEHICLES_MODEL_SUCCESS,
    payload: {
        vehicles_model
    }
});

export const getvehiclesModelFailure = err => ({
    type: GET_VEHICLES_MODEL_FAILURE,
    error: err
});

export const submitVehicleFileRequest = (vehicle_file, type) => ({
    type: SUBMIT_VEHICLE_FILE_REQUEST,
    payload: {
        vehicle_file,
        type
    }
});

export const submitVehicleFileSuccess = (vehicle_file) => ({
    type: SUBMIT_VEHICLE_FILE_SUCCESS,
    payload: {
        vehicle_file
    }
});

export const submitVehicleFileFailure = (err) => ({
    type: SUBMIT_VEHICLE_FILE_FAILURE,
    error: err
});

export const setVehicleFile = (vehicle_file = "") => ({
    type: SET_VEHICLE_FILE,
    payload: {
        vehicle_file
    }
});

export const setVehicles = (vehicles = []) => ({
    type: SET_VEHICLES,
    payload: {
        vehicles
    }
});